export default __webpack_public_path__ + "static/media/tafasillogo.dfcb12c4.jpg";